const epoch = () => Math.round(new Date().getTime() / 1000);

export default epoch;
